const appStorePng = require("./app-store/app-store.png");
const cambiumFooterSvg = require("./cambium-branding/cambium-footer-banner-desktop.svg");
const azulesPorUnDiaPng = require("./images/azulesPorUnDia.png");
const badgePng = require("./images/badge.png");
const bgBlueJpg = require("./images/bg-blue.jpg");
const bgGreyJpg = require("./images/bg-grey.jpg");
const bgYellowJpg = require("./images/bg-yellow.jpg");
const bicicletaAmarillaPng = require("./images/bicicletaAmarilla.png");
const bicicletaAzulPng = require("./images/bicicletaAzul.png");
const blueBridgeBottomSvg = require("./images/blue-bridge-bottom.svg");
const blueBridgeTopSvg = require("./images/blue-bridge-top.svg");
const blueSpinnerGif = require("./images/blue-spinner.gif");
const blueStoneSvg = require("./section-stones/blue-stone.svg");
const blueStoneWatermarkSvg = require("./images/blue-stone-watermark.svg");
const brushYellowBracketLeftPng = require("./text-emphasis/brush-yellow-bracket-left.png");
const brushYellowBracketRightPng = require("./text-emphasis/brush-yellow-bracket-right.png");
const brushYellowCirclePng = require("./text-emphasis/brush-yellow-circle.png");
const brushYellowCornerLeftPng = require("./text-emphasis/brush-yellow-corner-left.png");
const brushYellowCornerRightPng = require("./text-emphasis/brush-yellow-corner-right.png");
const brushYellowLinePng = require("./text-emphasis/brush-yellow-line.png");
const brushYellowListCircle_1Png = require("./text-emphasis/brush-yellow-list-circle-1.png");
const brushYellowListCircle_2Png = require("./text-emphasis/brush-yellow-list-circle-2.png");
const brushYellowListCircle_3Png = require("./text-emphasis/brush-yellow-list-circle-3.png");
const brushYellowListCircle_4Png = require("./text-emphasis/brush-yellow-list-circle-4.png");
const brushYellowSparkLeftPng = require("./text-emphasis/brush-yellow-spark-left.png");
const brushYellowSparkRightPng = require("./text-emphasis/brush-yellow-spark-right.png");
const busWebHomepage_2019Png = require("./images/BUS-web-homepage-2019.png");
const businessCirclePng = require("./images/business-circle.png");
const cartPng = require("./images/cart.png");
const cat2TutorScreenPng = require("./images/cat2-tutor-screen.png");
const closePng = require("./images/close.png");
const cnnBgPng = require("./images/cnn_bg.png");
const cnnLogoShadowedPng = require("./images/cnn_logo_shadowed.png");
const colorsInItalian_2819dJpg = require("./banners/colors-in-italian-2819d.jpg");
const constructionHeroPng = require("./images/Construction-hero.png");
const constructionPhoto1Png = require("./images/Construction-Photo1.png");
const constructionPhoto2Png = require("./images/Construction-Photo2.png");
const deviceLockupLargePng = require("./images/device_lockup_large.png");
const dosBicicletasAzulesPng = require("./images/dosBicicletasAzules.png");
const dosBicicletasDiferentesPng = require("./images/dosBicicletasDiferentes.png");
const educationPrimaryCirclePng = require("./verticals/education-primary-circle.png");
const educationSecondaryCirclePng = require("./verticals/education-secondary-circle.png");
const educatorsPng = require("./images/educators.png");
const emptyIphonePng = require("./images/empty-iphone.png");
const enterpriseCirclePng = require("./verticals/enterprise-circle.png");
const enterprisePng = require("./images/enterprise.png");
const facebookDarkSvg = require("./social/facebook-dark.svg");
const facebookIconSvg = require("./images/facebook-icon.svg");
const faviconIco = require("./images/favicon.ico");
const fb2Png = require("./images/fb2.png");
const fitbrainsBgJpg = require("./images/fitbrains-bg.jpg");
const foodserviceHeroPng = require("./images/Foodservice-hero.png");
const foodservicePhoto1Png = require("./images/Foodservice-Photo1.png");
const foodservicePhoto2Png = require("./images/Foodservice-Photo2.png");
const googlePlayPng = require("./app-store/google-play.png");
const googlePlusIconSvg = require("./images/google-plus-icon.svg");
const grayCurveBottomSvg = require("./page-section-borders/gray-curve-bottom.svg");
const grayCurveTopSvg = require("./page-section-borders/gray-curve-top.svg");
const grayStoneSvg = require("./section-stones/gray-stone.svg");
const hedCirclePng = require("./images/hed-circle.png");
const hedSection_1ImgPng = require("./images/hed-section-1-img.png");
const hedSection_5ImgPng = require("./images/hed-section-5-img.png");
const homepageWomanOnBalconyJpg = require("./images/HomepageWomanOnBalcony.jpg");
const homepageWomanOnBalconyMobileJpg = require("./images/HomepageWomanOnBalcony-mobile.jpg");
const homeschoolBgJpg = require("./images/homeschool-bg.jpg");
const hospitalityHeroPng = require("./images/Hospitality-hero.png");
const hospitalityPhoto1Png = require("./images/Hospitality-Photo1.png");
const hospitalityPhoto2Png = require("./images/Hospitality-Photo2.png");
const iconAssessmentsSvg = require("./icons/icon-assessments.svg");
const iconBookPng = require("./icons/icon-book.png");
const iconBriefcasePng = require("./icons/icon-briefcase.png");
const iconDynamicSvg = require("./icons/icon-dynamic.svg");
const iconFoundationalSvg = require("./icons/icon-foundational.svg");
const iconGamesSvg = require("./icons/icon-games.svg");
const iconGlobePng = require("./icons/icon-globe.png");
const iconHeartPng = require("./icons/icon-heart.png");
const iconImplementationSvg = require("./icons/icon-implementation.svg");
const iconMobileSvg = require("./icons/icon-mobile.svg");
const iconPlacementSvg = require("./icons/icon-placement.svg");
const iconProficiencySvg = require("./icons/icon-proficiency.svg");
const iconReadingSvg = require("./icons/icon-reading.svg");
const iconReportingSvg = require("./icons/icon-reporting.svg");
const iconSearchSvg = require("./icons/icon_search.svg");
const iconTrainingSvg = require("./icons/icon-training.svg");
const iconTransferableSvg = require("./icons/icon-transferable.svg");
const iconTruaccentSvg = require("./icons/icon-truaccent.svg");
const iconTutoringSvg = require("./icons/icon-tutoring.svg");
const icon_24Svg = require("./icons/icon-24.svg");
const indexJs = require("./logos/index.js");
const instagramDarkSvg = require("./social/instagram-dark.svg");
const iphoneBluePng = require("./images/iphone-blue.png");
const iphoneBlue_2xPng = require("./images/iphone-blue@2x.png");
const iphonexEngagingPng = require("./images/iphonex-engaging.png");
const iphonexImmersionPng = require("./images/iphonex-immersion.png");
const iphonexMobilePng = require("./images/iphonex-mobile.png");
const iphonexReportingtoolsPng = require("./images/iphonex-reportingtools.png");
const iphonexTruaccentPng = require("./images/iphonex-truaccent.png");
const iphonexTutoringPng = require("./images/iphonex-tutoring.png");
const iphonex_24Png = require("./images/iphonex-24.png");
const k12CirclePng = require("./images/k12-circle.png");
const k12Section_1ImgPng = require("./images/k12-section-1-img.png");
const k12Section_5ImgPng = require("./images/k12-section-5-img.png");
const kidsBgJpg = require("./images/kids-bg.jpg");
const kidsPng = require("./images/kids.png");
const langLearnJpg = require("./images/lang-learn.jpg");
const lightboxJpg = require("./images/lightbox.jpg");
const linkedinDarkPng = require("./social/linkedin-dark.png");
const logoAmgenPng = require("./logos/logo-amgen.png");
const logoBarSFoodSigmaPng = require("./logos/logo-bar-s-food-sigma.png");
const logoBellevueJpg = require("./logos/logo-bellevue.jpg");
const logoBethelPng = require("./logos/logo-bethel.png");
const logoBmwPng = require("./logos/logo-bmw.png");
const logoBullittPng = require("./logos/logo-bullitt.png");
const logoCalvinkleinSvg = require("./logos/logo-calvinklein.svg");
const logoCanterburyJpg = require("./logos/logo-canterbury.jpg");
const logoCaterpillarPng = require("./logos/logo-caterpillar.png");
const logoChickasawPng = require("./logos/logo-chickasaw.png");
const logoCincinnatiPng = require("./logos/logo-cincinnati.png");
const logoClarksvilleJpg = require("./logos/logo-clarksville.jpg");
const logoCnnBgSvg = require("./logos/logo-cnn-bg.svg");
const logoCnnSvg = require("./logos/logo-cnn.svg");
const logoColorNotextSvg = require("./rs-branding/logo-color-notext.svg");
const logoCoronaPng = require("./logos/logo-corona.png");
const logoCrowderPng = require("./logos/logo-crowder.png");
const logoCvsHealthPng = require("./logos/logo-cvs-health.png");
const logoDprPng = require("./logos/logo-dpr.png");
const logoEonPng = require("./logos/logo-eon.png");
const logoFairfaxPng = require("./logos/logo-fairfax.png");
const logoFenderSvg = require("./logos/logo-fender.svg");
const logoFicoPng = require("./logos/logo-fico.png");
const logoFlorettePng = require("./logos/logo-florette.png");
const logoGeorgesPng = require("./logos/logo-georges.png");
const logoGilbanePng = require("./logos/logo-gilbane.png");
const logoGmPng = require("./logos/logo-gm.png");
const logoGuthrieJpg = require("./logos/logo-guthrie.jpg");
const logoHarrogateJpg = require("./logos/logo-harrogate.jpg");
const logoHitachiPng = require("./logos/logo-hitachi.png");
const logoHumboldtPng = require("./logos/logo-humboldt.png");
const logoIkeaPng = require("./logos/logo-ikea.png");
const logoKimberlyClarkPng = require("./logos/logo-kimberly-clark.png");
const logoKonicaPng = require("./logos/logo-konica.png");
const logoLamResearchPng = require("./logos/logo-lam-research.png");
const logoLeclercPng = require("./logos/logo-leclerc.png");
const logoLibertyPng = require("./logos/logo-liberty.png");
const logoMacworldBgSvg = require("./logos/logo-macworld-bg.svg");
const logoMacworldSvg = require("./logos/logo-macworld.svg");
const logoMarriottInternationalPng = require("./logos/logo-marriott-international.png");
const logoMashableSvg = require("./logos/logo-mashable.svg");
const logoNeaJpg = require("./logos/logo-nea.jpg");
const logoNorlingtonJpg = require("./logos/logo-norlington.jpg");
const logoNorthernBorderPng = require("./logos/logo-northern-border.png");
const logoNycHealthPng = require("./logos/logo-nyc-health.png");
const logoOreillyPng = require("./logos/logo-oreilly.png");
const logoPcmagPng = require("./logos/logo-pcmag.png");
const logoPcmag_2Png = require("./logos/logo-pcmag-2.png");
const logoPhilipMorrisInternationalPng = require("./logos/logo-philip-morris-international.png");
const logoPhoenixPng = require("./logos/logo-phoenix.png");
const logoPphePng = require("./logos/logo-pphe.png");
const logoPuebloPng = require("./logos/logo-pueblo.png");
const logoRaleighJpg = require("./logos/logo-raleigh.jpg");
const logoSonyPicturesPng = require("./logos/logo-sony-pictures.png");
const logoTechcrunchBgSvg = require("./logos/logo-techcrunch-bg.svg");
const logoTechcrunchSvg = require("./logos/logo-techcrunch.svg");
const logoTishmanSpeyerPng = require("./logos/logo-tishman-speyer.png");
const logoTripadvisor2Png = require("./logos/logo-tripadvisor2.png");
const logoTripadvisorPng = require("./logos/logo-tripadvisor.png");
const logoTripadvisorSvg = require("./logos/logo-tripadvisor.svg");
const logoTwitterPng = require("./logos/logo-twitter.png");
const logoUcbPng = require("./logos/logo-ucb.png");
const logoViPng = require("./logos/logo-vi.png");
const logoVodafonePng = require("./logos/logo-vodafone.png");
const logoWilliamsSonomaPng = require("./logos/logo-williams-sonoma.png");
const macworldBgPng = require("./images/macworld_bg.png");
const macworldLogoShadowedPng = require("./images/macworld_logo_shadowed.png");
const manufacturingHeroPng = require("./images/Manufacturing-hero.png");
const manufacturingPhoto1Png = require("./images/Manufacturing-Photo1.png");
const manufacturingPhoto2Png = require("./images/Manufacturing-Photo2.png");
const mastheadBgDesktopFranceJpg = require("./images/masthead_bg_desktop_france.jpg");
const mastheadBgDesktopPng = require("./images/masthead_bg_desktop.png");
const mastheadBgMobileFranceJpg = require("./images/masthead_bg_mobile_france.jpg");
const mastheadBgMobilePng = require("./images/masthead_bg_mobile.png");
const maunfacturingPhoto2Png = require("./images/Maunfacturing-Photo2.png");
const newWindowPng = require("./images/new-window.png");
const playBtnPng = require("./images/Play-btn.png");
const pricingBgSvg = require("./images/pricing-bg.svg");
const pricingBottomSvg = require("./images/pricing-bottom.svg");
const pricingTopSvg = require("./images/pricing-top.svg");
const proServicesHeroPng = require("./images/ProServices-hero.png");
const proServicesPhoto1Png = require("./images/ProServices-Photo1.png");
const proServicesPhoto2Png = require("./images/ProServices-Photo2.png");
const pubCirclePng = require("./images/pub-circle.png");
const publicsectorCirclePng = require("./verticals/publicsector-circle.png");
const pubsecSection_1ImgPng = require("./images/pubsec-section-1-img.png");
const pubsecSection_5ImgPng = require("./images/pubsec-section-5-img.png");
const relatedBottomSvg = require("./images/related-bottom.svg");
const relatedTopSvg = require("./images/related-top.svg");
const resourcesPng = require("./images/resources.png");
const retailHeroPng = require("./images/Retail-hero.png");
const retailPhoto1Png = require("./images/Retail-Photo1.png");
const retailPhoto2Png = require("./images/Retail-Photo2.png");
const rsBannerTransparentPng = require("./rs-branding/rs-banner-transparent.png");
const rsLogoBlackSvg = require("./rs-branding/rs-logo-black.svg");
const rsLogoHeaderSvg = require("./rs-branding/rs-logo-header.svg");
const rsLogoOriginalSvg = require("./rs-branding/rs_logo_original.svg");
const rsLogoSvg = require("./rs-branding/rs-logo.svg");
const rsLogoWhiteSvg = require("./rs-branding/rs-logo-white.svg");
const rsLogoWhite_2Svg = require("./rs-branding/rs-logo-white-2.svg");
const rsStoneFooterSvg = require("./rs-branding/rs-stone-footer.svg");
const screenAssessmentPng = require("./images/screen-assessment.png");
const screenImplementationPng = require("./images/screen-implementation.png");
const screenPlacementPng = require("./images/screen-placement.png");
const screenReportingPng = require("./images/screen-reporting.png");
const screenTestingPng = require("./images/screen-testing.png");
const screenTrainingPng = require("./images/screen-training.png");
const section_1Img_1Png = require("./images/section-1-img-1.png");
const section_1Img_1_2xPng = require("./images/section-1-img-1@2x.png");
const section_1Img_2Png = require("./images/section-1-img-2.png");
const section_1StoneGreySvg = require("./images/section-1-stone-grey.svg");
const section_2StoneBlueSvg = require("./images/section-2-stone-blue.svg");
const section_3StoneGreySvg = require("./images/section-3-stone-grey.svg");
const section_4StoneYellowSvg = require("./images/section-4-stone-yellow.svg");
const section_5Img_1Png = require("./images/section-5-img-1.png");
const section_5Img_1_2xPng = require("./images/section-5-img-1@2x.png");
const section_5Img_2Png = require("./images/section-5-img-2.png");
const section_5Img_2_2xPng = require("./images/section-5-img-2@2x.png");
const section_5StoneGreySvg = require("./images/section-5-stone-grey.svg");
const section_6StoneGreySvg = require("./images/section-6-stone-grey.svg");
const section_7StoneBlueSvg = require("./images/section-7-stone-blue.svg");
const solHealthcareSection_2ImgPng = require("./images/sol-healthcare-section-2-img.png");
const solHealthcareSection_4ImgPng = require("./images/sol-healthcare-section-4-img.png");
const solK12Section_1ImgJpg = require("./images/sol-k12-section-1-img.jpg");
const solK12Section_2ImgPng = require("./images/sol-k12-section-2-img.png");
const solK12Section_4ImgPng = require("./images/sol-k12-section-4-img.png");
const solSection_1ImgPng = require("./images/sol-section-1-img.png");
const solSection_1StoneBlueSvg = require("./images/sol-section-1-stone-blue.svg");
const solSection_2ImgPng = require("./images/sol-section-2-img.png");
const solSection_3StoneYellowSvg = require("./images/sol-section-3-stone-yellow.svg");
const solSection_4ImgPng = require("./images/sol-section-4-img.png");
const solSection_7StoneBlueSvg = require("./images/sol-section-7-stone-blue.svg");
const solSection_7StoneYellowSvg = require("./images/sol-section-7-stone-yellow.svg");
const supportPng = require("./images/support.png");
const techcrunchBgPng = require("./images/techcrunch_bg.png");
const techcrunchLogoShadowedPng = require("./images/techcrunch_logo_shadowed.png");
const thankYouMultilanguagePng = require("./images/thank-you-multilanguage.png");
const threeWomenPhonePng = require("./images/three-women-phone.png");
const triScreenLockupPng = require("./images/tri-screen-lockup.png");
const triScreenLockupV2Png = require("./images/tri-screen-lockup-v2.png");
const tutorScreenPng = require("./images/tutor-screen.png");
const tutorScreen_0_5xPng = require("./images/tutor-screen@0.5x.png");
const tutorScreen_2xPng = require("./images/tutor-screen@2x.png");
const twitterDarkSvg = require("./social/twitter-dark.svg");
const twitterIconSvg = require("./images/twitter-icon.svg");
const usEnterpriseCampaignMtcGif = require("./animations/us-enterprise-campaign-mtc.gif");
const usEnterpriseCutCostsGif = require("./cards/us-enterprise-cut-costs.gif");
const usEnterpriseLearnerSuccessGif = require("./cards/us-enterprise-learner-success.gif");
const usEnterpriseTopTalentGif = require("./cards/us-enterprise-top-talent.gif");
const usEnterpriseWorkBetterGif = require("./cards/us-enterprise-work-better.gif");
const verdesPorUnDiaPng = require("./images/verdesPorUnDia.png");
const videoStillJourneyJpg = require("./images/video_still_journey.jpg");
const yearsBubbleLargePng = require("./images/years_bubble_large.png");
const yearsBubbleMobilePng = require("./images/years_bubble_mobile.png");
const yearsBubblePng = require("./images/years_bubble.png");
const yearsWatermarkPng = require("./images/years_watermark.png");
const yellowBridgeFooterSvg = require("./trustpilot/yellow-bridge-footer.svg");
const yellowBridgeHeaderSvg = require("./trustpilot/yellow-bridge-header.svg");
const yellowCurveBottomSvg = require("./page-section-borders/yellow-curve-bottom.svg");
const yellowCurveTopSvg = require("./page-section-borders/yellow-curve-top.svg");
const yellowStoneSvg = require("./section-stones/yellow-stone.svg");
const youtubeDarkSvg = require("./social/youtube-dark.svg");
const youtubeIconSvg = require("./images/youtube-icon.svg");
const zonTheGo1Png = require("./images/zon-the-go1.png");
const zonTheGo2Png = require("./images/zon-the-go2.png");

module.exports = {
    animations: {
        usEnterpriseCampaignMtcGif
    },
    appStore: {
        appStorePng,
        googlePlayPng
    },
    banners: {
        colorsInItalian_2819dJpg
    },
    cambiumBranding: {
        cambiumFooterSvg
    },
    cards: {
        usEnterpriseCutCostsGif,
        usEnterpriseLearnerSuccessGif,
        usEnterpriseTopTalentGif,
        usEnterpriseWorkBetterGif
    },
    icons: {
        icon_24Svg,
        iconAssessmentsSvg,
        iconBookPng,
        iconBriefcasePng,
        iconDynamicSvg,
        iconFoundationalSvg,
        iconGamesSvg,
        iconGlobePng,
        iconHeartPng,
        iconImplementationSvg,
        iconMobileSvg,
        iconPlacementSvg,
        iconProficiencySvg,
        iconReadingSvg,
        iconReportingSvg,
        iconTrainingSvg,
        iconTransferableSvg,
        iconTruaccentSvg,
        iconTutoringSvg,
        iconSearchSvg
    },
    images: {
        busWebHomepage_2019Png,
        constructionPhoto1Png,
        constructionPhoto2Png,
        constructionHeroPng,
        foodservicePhoto1Png,
        foodservicePhoto2Png,
        foodserviceHeroPng,
        homepageWomanOnBalconyMobileJpg,
        homepageWomanOnBalconyJpg,
        hospitalityPhoto1Png,
        hospitalityPhoto2Png,
        hospitalityHeroPng,
        manufacturingPhoto1Png,
        manufacturingPhoto2Png,
        manufacturingHeroPng,
        maunfacturingPhoto2Png,
        playBtnPng,
        proServicesPhoto1Png,
        proServicesPhoto2Png,
        proServicesHeroPng,
        retailPhoto1Png,
        retailPhoto2Png,
        retailHeroPng,
        azulesPorUnDiaPng,
        badgePng,
        bgBlueJpg,
        bgGreyJpg,
        bgYellowJpg,
        bicicletaAmarillaPng,
        bicicletaAzulPng,
        blueBridgeBottomSvg,
        blueBridgeTopSvg,
        blueSpinnerGif,
        blueStoneWatermarkSvg,
        businessCirclePng,
        cartPng,
        cat2TutorScreenPng,
        closePng,
        cnnBgPng,
        cnnLogoShadowedPng,
        deviceLockupLargePng,
        dosBicicletasAzulesPng,
        dosBicicletasDiferentesPng,
        educatorsPng,
        emptyIphonePng,
        enterprisePng,
        facebookIconSvg,
        faviconIco,
        fb2Png,
        fitbrainsBgJpg,
        googlePlusIconSvg,
        hedCirclePng,
        hedSection_1ImgPng,
        hedSection_5ImgPng,
        homeschoolBgJpg,
        iphoneBluePng,
        iphoneBlue_2xPng,
        iphonex_24Png,
        iphonexEngagingPng,
        iphonexImmersionPng,
        iphonexMobilePng,
        iphonexReportingtoolsPng,
        iphonexTruaccentPng,
        iphonexTutoringPng,
        k12CirclePng,
        k12Section_1ImgPng,
        k12Section_5ImgPng,
        kidsBgJpg,
        kidsPng,
        langLearnJpg,
        lightboxJpg,
        macworldBgPng,
        macworldLogoShadowedPng,
        mastheadBgDesktopPng,
        mastheadBgDesktopFranceJpg,
        mastheadBgMobilePng,
        mastheadBgMobileFranceJpg,
        newWindowPng,
        pricingBgSvg,
        pricingBottomSvg,
        pricingTopSvg,
        pubCirclePng,
        pubsecSection_1ImgPng,
        pubsecSection_5ImgPng,
        relatedBottomSvg,
        relatedTopSvg,
        resourcesPng,
        screenAssessmentPng,
        screenImplementationPng,
        screenPlacementPng,
        screenReportingPng,
        screenTestingPng,
        screenTrainingPng,
        section_1Img_1Png,
        section_1Img_1_2xPng,
        section_1Img_2Png,
        section_1StoneGreySvg,
        section_2StoneBlueSvg,
        section_3StoneGreySvg,
        section_4StoneYellowSvg,
        section_5Img_1Png,
        section_5Img_1_2xPng,
        section_5Img_2Png,
        section_5Img_2_2xPng,
        section_5StoneGreySvg,
        section_6StoneGreySvg,
        section_7StoneBlueSvg,
        solHealthcareSection_2ImgPng,
        solHealthcareSection_4ImgPng,
        solK12Section_1ImgJpg,
        solK12Section_2ImgPng,
        solK12Section_4ImgPng,
        solSection_1ImgPng,
        solSection_1StoneBlueSvg,
        solSection_2ImgPng,
        solSection_3StoneYellowSvg,
        solSection_4ImgPng,
        solSection_7StoneBlueSvg,
        solSection_7StoneYellowSvg,
        supportPng,
        techcrunchBgPng,
        techcrunchLogoShadowedPng,
        thankYouMultilanguagePng,
        threeWomenPhonePng,
        triScreenLockupV2Png,
        triScreenLockupPng,
        tutorScreenPng,
        tutorScreen_0_5xPng,
        tutorScreen_2xPng,
        twitterIconSvg,
        verdesPorUnDiaPng,
        videoStillJourneyJpg,
        yearsBubblePng,
        yearsBubbleLargePng,
        yearsBubbleMobilePng,
        yearsWatermarkPng,
        youtubeIconSvg,
        zonTheGo1Png,
        zonTheGo2Png
    },
    logos: {
        indexJs,
        logoAmgenPng,
        logoBarSFoodSigmaPng,
        logoBellevueJpg,
        logoBethelPng,
        logoBmwPng,
        logoBullittPng,
        logoCalvinkleinSvg,
        logoCanterburyJpg,
        logoCaterpillarPng,
        logoChickasawPng,
        logoCincinnatiPng,
        logoClarksvilleJpg,
        logoCnnBgSvg,
        logoCnnSvg,
        logoCoronaPng,
        logoCrowderPng,
        logoCvsHealthPng,
        logoDprPng,
        logoEonPng,
        logoFairfaxPng,
        logoFenderSvg,
        logoFicoPng,
        logoFlorettePng,
        logoGeorgesPng,
        logoGilbanePng,
        logoGmPng,
        logoGuthrieJpg,
        logoHarrogateJpg,
        logoHitachiPng,
        logoHumboldtPng,
        logoIkeaPng,
        logoKimberlyClarkPng,
        logoKonicaPng,
        logoLamResearchPng,
        logoLeclercPng,
        logoLibertyPng,
        logoMacworldBgSvg,
        logoMacworldSvg,
        logoMarriottInternationalPng,
        logoMashableSvg,
        logoNeaJpg,
        logoNorlingtonJpg,
        logoNorthernBorderPng,
        logoNycHealthPng,
        logoOreillyPng,
        logoPcmag_2Png,
        logoPcmagPng,
        logoPhilipMorrisInternationalPng,
        logoPhoenixPng,
        logoPphePng,
        logoPuebloPng,
        logoRaleighJpg,
        logoSonyPicturesPng,
        logoTechcrunchBgSvg,
        logoTechcrunchSvg,
        logoTishmanSpeyerPng,
        logoTripadvisorPng,
        logoTripadvisorSvg,
        logoTripadvisor2Png,
        logoTwitterPng,
        logoUcbPng,
        logoViPng,
        logoVodafonePng,
        logoWilliamsSonomaPng
    },
    pageSectionBorders: {
        grayCurveBottomSvg,
        grayCurveTopSvg,
        yellowCurveBottomSvg,
        yellowCurveTopSvg
    },
    rsBranding: {
        logoColorNotextSvg,
        rsBannerTransparentPng,
        rsLogoBlackSvg,
        rsLogoHeaderSvg,
        rsLogoWhite_2Svg,
        rsLogoWhiteSvg,
        rsLogoSvg,
        rsStoneFooterSvg,
        rsLogoOriginalSvg
    },
    sectionStones: {
        blueStoneSvg,
        grayStoneSvg,
        yellowStoneSvg
    },
    social: {
        facebookDarkSvg,
        instagramDarkSvg,
        linkedinDarkPng,
        twitterDarkSvg,
        youtubeDarkSvg
    },
    textEmphasis: {
        brushYellowBracketLeftPng,
        brushYellowBracketRightPng,
        brushYellowCirclePng,
        brushYellowCornerLeftPng,
        brushYellowCornerRightPng,
        brushYellowLinePng,
        brushYellowListCircle_1Png,
        brushYellowListCircle_2Png,
        brushYellowListCircle_3Png,
        brushYellowListCircle_4Png,
        brushYellowSparkLeftPng,
        brushYellowSparkRightPng
    },
    trustpilot: {
        yellowBridgeFooterSvg,
        yellowBridgeHeaderSvg
    },
    verticals: {
        educationPrimaryCirclePng,
        educationSecondaryCirclePng,
        enterpriseCirclePng,
        publicsectorCirclePng
    }
};
